<template>
  <div class="offcanvas-body">
    <PasswordInput
      label="Senha"
      :model="oldPasswordModel"
      placeholder="Senha atual"
    />
    <PasswordInput
      label="Nova senha"
      :model="passwordModel"
      placeholder="Mínimo de 8 caracteres"
    />
    <PasswordInput
      label="Confirme a senha"
      :model="passwordConfirmationModel"
      placeholder="Confirme sua senha"
      errorMsg="As senhas nao coincidem"
    />
    <div class="row">
      <div class="col-12 text-center">
        <span class="text-danger text-center">{{ errorMessage }}</span>
      </div>
    </div>

    <FormButton
      class="w-100"
      label="Concluir"
      :disabled="!meta.valid"
      @onClick="submit"
      :marginVertical="false"
      :loading="submitting"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import { toTypedSchema } from "@vee-validate/zod";
import { useForm } from "vee-validate";
import { useVeeField } from "@/composables/useVeeField";
import { passwordUpdateSchema } from "@/schemas/account";
import { useSessionStore } from "@/store/useSessionStore";
import { EventBus, EventBusNames } from "@/utils/EventBus";
import { toggleOffcanvas } from "@/utils/Helper";
import { useUpdateUser } from "@/composables/useAuth";

const sessionStore = useSessionStore();
const session = computed(() => sessionStore.session);
const submitting = ref(false);
const errorMessage = ref("");

const { handleSubmit, meta } = useForm({
  validationSchema: toTypedSchema(passwordUpdateSchema),
  initialValues: {
    old_password: "",
    password: "",
    passwordConfirmation: "",
  },
});

const oldPasswordModel = useVeeField("old_password");
const passwordModel = useVeeField("password");
const passwordConfirmationModel = useVeeField("passwordConfirmation");

const { mutateAsync: updateUser } = useUpdateUser();

const submit = handleSubmit(async (values) => {
  try {
    submitting.value = true;
    errorMessage.value = "";
    await updateUser({
      id: session.value!.id,
      old_password: values.old_password,
      password: values.password,
    });
    EventBus.$emit(EventBusNames.SHOW_TOAST, {
      title: "Senha alterada",
      msg: "Sua senha foi alterada com sucesso",
    });
    toggleOffcanvas("offcanvas_views");
  } catch (error: any) {
    errorMessage.value = error.message;
  } finally {
    submitting.value = false;
  }
});
</script>
